module.exports = __webpack_public_path__ + "static/media/picto-close-black.c63435d7.svg";